import { render, staticRenderFns } from "./GroupPage.vue?vue&type=template&id=0c128122&scoped=true&"
import script from "./GroupPage.vue?vue&type=script&lang=js&"
export * from "./GroupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c128122",
  null
  
)

export default component.exports